import { MetaProvider, Title } from '@solidjs/meta';
import './app.css';
import { withSentryRouterRouting } from '@sentry/solidstart/solidrouter';
import { breadcrumbsIntegration, init as initSentry } from '@sentry/solidstart';
import { Router } from '@solidjs/router';
import { FileRoutes } from '@solidjs/start/router';
import { UIProvider } from '@troon/ui';
import { ErrorBoundary } from 'solid-js';
import { ActivationProvider } from './context/activation';
import { UserProvider } from './context/user';

const SentryRouter = withSentryRouterRouting(Router);

if (window.__CONFIG__.env === 'production') {
	initSentry({
		dsn: window.__CONFIG__.sentryDsn,
		environment: window.__CONFIG__.env,
		release: window.__CONFIG__.sha,
		ignoreErrors: [
			/AsyncLocalStorage/,
			/resizeobserver loop/i,
			/transition was (aborted|skipped)/i,
			/view transition/,
			'Attempted to assign to readonly property',
			/This tee time is no longer available/,
			/Invalid `prisma\./i,
			/fetch is aborted/i,
			/failed to fetch/i,
			/(load|fetch) failed/i,
		],
		integrations: [
			breadcrumbsIntegration({
				history: true,
				sentry: true,
			}),
		],
	});
}

export default function App() {
	return (
		<ActivationProvider>
			<MetaProvider>
				<Title>Troon Booking</Title>
				<SentryRouter
					base="/embed"
					explicitLinks
					preload
					root={(props) => (
						<ErrorBoundary fallback={null}>
							<UIProvider baseUrl={`https://${window.location.host}`}>
								<UserProvider>{props.children}</UserProvider>
							</UIProvider>
						</ErrorBoundary>
					)}
				>
					<FileRoutes />
				</SentryRouter>
			</MetaProvider>
		</ActivationProvider>
	);
}
